// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"style_placeholder__10xX9","editor":"style_editor__8U5RG","wrapper":"style_wrapper__2niuC","toolbar":"style_toolbar__1kOZI"};